import React from 'react';

import { CryptoAccountTransactionDetailsItem } from '@/components/molecules/CryptoAccountTransactionDetailsItem';
import { FiatAccountTransactionDetailsItem } from '@/components/molecules/FiatAccountTransactionDetailsItem';
import { RecipientTransactionDetailsItem } from '@/components/molecules/RecipientTransactionDetailsItem';
import { BitsoBank } from '@/types/bitsoBank';
import { Account, isFiatAccount } from '@/types/contacts';
import { isRecipientResponse, RecipientResponse } from '@/types/recipient';

interface Props {
  readonly account: Account | RecipientResponse | null;
  readonly banks: readonly BitsoBank[];
}

export const AccountTransactionDetailsItem: React.FC<Props> = (
  props: Props,
): React.ReactElement => {
  const { account, banks } = props;

  if (account === null) {
    console.debug('AccountTransactionDetailsItem: account is null');
    return <></>;
  }

  if (isRecipientResponse(account)) {
    return <RecipientTransactionDetailsItem recipient={account} banks={banks} />;
  } else if (isFiatAccount(account)) {
    return <FiatAccountTransactionDetailsItem account={account} banks={banks} />;
  } else {
    return <CryptoAccountTransactionDetailsItem account={account} />;
  }
};
